<template>
	<view class="box">
		<view class="box_head">
			<view class="box_head_top">
				<image src="@/static/icon/cart_ic_select@2x.png" mode="widthFix"></image>
				<text>已取消</text>
			</view>
			<view class="box_head_info">订单已取消，去看看其他的吧</view>
			<view class="box_head_btn">
				<view class="item">返回商城</view>
				<view class="item">查看订单</view>
			</view>
		</view>
		<view class="order_list">
			<view class="order_list_head">
				<image src="@/static/icon/title_left@2x.png" mode="widthFix"></image>
				<text>你可能还喜欢</text>
				<image src="@/static/icon/title_right@2x.png" mode="widthFix"></image>
			</view>
			<view class="order_list_box">
				<view class="fun_list_item" v-for="(item, index) in 3" :key="index">
					<view class="fun_list_item_img">
						<image src="@/static/uni.png" mode="heightFix"></image>
					</view>
					<view class="fun_list_item_info">
						<view class="fun_list_item_info_top">
							<text>飞盘之后，新中产又被围炉煮茶割韭菜？飞盘之后，新中产又</text>
						</view>
						<view class="fun_list_item_info_bottom">
							<view class="fun_list_item_info_bottom_left">
								<text>¥</text>
								<text>179</text>
							</view>
							<view class="fun_list_item_info_bottom_right">
								<text>已售619份</text>
							</view>
						</view>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_head {
			display: flex;
			align-items: center;
			flex-direction: column;
			margin-top: 8rpx;
			.box_head_top {
				display: flex;
				align-items: center;
				justify-content: center;	
				image {
					width: 44rpx;
					height: 44rpx;
					margin-right: 8rpx;
				}
				text {
					font-size: 48rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.box_head_info {
				font-size: 28rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				margin-top: 20rpx;
			}
			.box_head_btn {
				width: 364rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 44rpx;
				.item {
					width: 144rpx;
					height: 52rpx;
					line-height: 52rpx;
					text-align: center;
					border-radius: 30rpx;
					border: 2rpx solid #D9D9D9;
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
			}
		}
		.order_list {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 48rpx;
			.order_list_head {
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 33rpx;
					height: 8rpx;
				}
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					margin: 0 16rpx;
				}
			}
			.order_list_box {
				margin-top: 32rpx;
				width: 100%;
				padding: 0 32rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
				.fun_list_item {
					width: 332rpx;
					height: 580rpx;
					border-radius: 20rpx;
					background-color: white;
					overflow: hidden;
					margin-bottom: 16rpx;
					.fun_list_item_img {
						width: 100%;
						height: 420rpx;
						display: flex;
						align-items: center;
						justify-content: center;
						overflow: hidden;
						image {
							height: 100%;
						}
					}
					.fun_list_item_info {
						width: 100%;
						padding: 16rpx 12rpx 24rpx 12rpx;
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						.fun_list_item_info_top {
							width: 100%;
							-webkit-line-clamp: 2;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							text-overflow: ellipsis;
							overflow: hidden;
							text {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
							}
						}
						.fun_list_item_info_bottom {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-top: 15rpx;
							.fun_list_item_info_bottom_left {
								display: flex;
								align-items: center;
								text {
									&:first-child {
										font-size: 20rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
										margin-top: 11rpx;
									}
									&:last-child {
										font-size: 32rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #D20A0A;
									}
								}
							}
							.fun_list_item_info_bottom_right {
								display: flex;
								align-items: center;
								text {
									font-size: 24rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #999999;
								}
							}
						}
					}
				}
			}
		}
	}
</style>